<div class="container  align-items-center">
  <!-- <div class="card card-container  "> -->
  <div class="card-header" [ngStyle]="{'background-color': onderneming?.kleur }">
  </div>
  <div class="">
    <div class="row">
      <h1 class="col-10 cardHeader card-title text-left"><strong>Bereken VAA bedrijfswagens</strong></h1>
      <div class="col-2 text-right mt-2">
        <a class="backButton" [routerLink]="['/',onderneming.naam,'tools']">
          <i class="fa fa-arrow-left fa-2x" aria-hidden="true"></i>
        </a>

      </div>

    </div>

    <h6 class="card-subtitle mb-5 mobileTussentitel text-muted text-left">Bereken het voordeel van alle aard wanneer een
      bedrijfswagen
      ook voor persoonlijk gebruik ter beschikking wordt gesteld.</h6>
    <div class=" row ">
      <div class="col-12">

        <form [formGroup]="vaaFormGroup" (ngSubmit)="onSubmit()">
          <div class="form-row">

            <div class="form-group col-md-6">
              <label class="font-weight-bold" for="waardeWagen">CATALOGUSWAARDE</label>
              <!-- <div *ngIf="vaaFormGroup.controls.waardeWagen.errors" class="text-danger md-1" >
                  De cataloguswaarde van uw wagen moet ingevuld worden.
                </div> -->
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">€</span>
                </div>
                <input ng-valid formControlName="waardeWagen" type="number" name="waardeWagen" step="any"
                  placeholder="0.00" min=0 class="form-control" id="waardeWagen" required>
              </div>



            </div>
            <div class="form-group col-md-6">
              <!--Tooltip bij Co2 (momenteel niet dynamisch)-->
              <label class="font-weight-bold" for="co2Emissie">CO2-EMISSIE
                <i placement="top"
                  ngbTooltip='Bepaalde plug-in hybride bedrijfswagens die vanaf 2018 deel uitmaken van het wagenpark, worden vanaf 1 januari 2020 duurder voor werknemer en werkgever. Dit geldt voor plug-in hybrides met een CO2-uitstoot van meer dan 50gr/km of waarvan de elektrische batterij een energiecapaciteit heeft van minder dan 0,5 kWh per 100kg van het wagengewicht. Voor de berekening van het voordeel van alle aard, moet je de CO2-uitstoot vervangen door de CO2-uitstoot van het overeenstemmende voertuig op fossiele brandstof. De autofabrikant of -invoerder levert dit aan. Bij gebrek daaraan,vermenigvuldig je de CO2-uitstoot van de plug-in hybride met de factor 2,5'
                  tooltipClass="width-tooltip" class="fa  size-tooltip-icon color-tooltip-icon fa-question-circle ml-1"
                  aria-hidden="true"></i>
              </label>
              <input type="number" formControlName="co2Emissie" step="any" name="co2Emissie" value=0 placeholder="0.00"
                min=0 class="form-control" id="co2Emissie">
            </div>
          </div>
          <div class="form-row">

            <div class="form-group col-md-6">
              <label class="font-weight-bold" for="inputBrandstof">BRANDSTOFTYPE</label>
              <select id="inputBrandstof" formControlName="brandstofType" name="inputBrandstof" class="form-control"
                required>
                <option *ngFor="let b of brandstoftypeDropDown" [value]="b">{{b}}</option>
              </select>
            </div>
            <div class="form-group col-md-6">
              <label class="font-weight-bold" for="datumInschrijving">EERSTE INSCHRIJVING</label>
              <input type="date" formControlName="datumInschrijving" required name="datumInschrijving"
                class="form-control" id="datumInschrijving">
            </div>
          </div>
          <div class="text-right">
            <button type="submit" [disabled]="!vaaFormGroup.valid"
              class="btn btn-outline-secondary mt-1">BEREKEN</button>
          </div>

        </form>
      </div>
      <div class="col-12 mobile">
        <div *ngIf="!calculate" class="d-flex text-center w-100 h-100 " style="min-width: auto; min-height: 6em;">
          <div class="card-body d-flex align-items-center ">
            <p class="placeholder text-center w-100">vul het formulier in om resultaat te krijgen.</p>
          </div>



        </div>


        <div *ngIf="calculate" class=" xMargin">
          <div  class=" text-center w-100 d-flex h-100">
            <div class="kaderResultaat  col-md-6 mt-4 mb-4">
              <h3 [ngStyle]="{'color': onderneming?.kleurKnoppen }" style="font-weight: bolder;">Jaarlijkse VAA</h3>
              <h2 class="mt-4">{{result | currency:'EUR'}}</h2>
            </div>
            <!-- <div class="border-top w-100 pt-2"></div> -->
            <div class="kaderResultaat  col-md-6 mobile  mt-4 mb-4">
              <h3 [ngStyle]="{'color': onderneming?.kleurKnoppen }" style="font-weight: bolder;">Maandelijkse VAA</h3>
              <h2 class="mt-4">{{result / 12 | currency: 'EUR'}}</h2>
            </div>

            

          </div>
          <!--Op aanvraag van besox: knop met "Vraag offerte aan" -->
          <div *ngIf="onderneming.naam == 'Besox'" class="w-100 horizontalCenter d-flex mb-3">
            <div class="  ">
              <a type="button" href="https://www.besox.be/offerte-aanvragen/" class="pt-3 pb-3 btn btn-info btnOfferte">Vraag
                offerte aan</a>

            </div>
          </div>
        </div>


      </div>
    </div>


    <div class="card-bottom col-12 mobile" [ngStyle]="{'background-color': onderneming?.kleur }"></div>
    <div class="mt-4 row h-100">
      <p class="text-center mx-auto font-italic">
        {{dataService.onderneming?.algemeneWaarschuwing }}
      </p>
    </div>


  </div>

  <!-- </div> -->
</div>